import { render, staticRenderFns } from "./GetStarted.vue?vue&type=template&id=9290524e&"
import script from "./GetStarted.vue?vue&type=script&lang=js&"
export * from "./GetStarted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports